import { CustomerRepository } from "../../repositories/CustomerRepository";
import {
  CustomerOperationResult,
  CustomerEntity,
} from "../../entities/CustomerEntity";

/**
 * Create Customer Use Case
 * Creates a new customer in the system
 */
export class CreateCustomerUseCase {
  constructor(private repository: CustomerRepository) {}

  async execute(
    customerData: Partial<CustomerEntity>
  ): Promise<CustomerOperationResult> {
    // Validate required fields

    return await this.repository.createCustomer(customerData);
  }
}
